import { useReducer } from 'react';

const initialState = {
  searchValue: '',
  newOptionValue: '',
  newOptionError: '',
  isAdding: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_SEARCH_VALUE':
      return { ...state, searchValue: action.payload };
    case 'START_ADDING':
      return { ...state, isAdding: true };
    case 'CANCEL_ADDING':
      return { ...state, isAdding: false, newOptionValue: '', newOptionError: '' };
    case 'SET_NEW_OPTION_VALUE':
      return { ...state, newOptionValue: action.payload };
    case 'SET_NEW_OPTION_ERROR':
      return { ...state, newOptionError: action.payload };
    case 'RESET_NEW_OPTION_STATE':
      return { ...state, newOptionValue: '', newOptionError: '', isAdding: false };
    default:
      return state;
  }
};

export const useCheckboxFilterReducer = () => {
  return useReducer(reducer, initialState);
};
